import { useSuspenseQuery } from "@tanstack/react-query";

import { apiGetSymptomsListOptions, type SupportedSymptom } from "../api";

/**
 * Supported-symptoms catalog — global reference data, fetched once per session.
 * `useSupportedSymptoms` for components (suspends until loaded).
 */
function supportedSymptomsQuery() {
  return { ...apiGetSymptomsListOptions(), staleTime: Infinity };
}

export function useSupportedSymptoms(): SupportedSymptom[] {
  // Suspends the nearest boundary until loaded, so callers always get data.
  return useSuspenseQuery(supportedSymptomsQuery()).data.symptoms;
}
